import styles from "./TrainersSection.module.scss";
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import SectionSubtitle from "../../../components/UI/SectionSubtitle/SectionSubtitle";
import React, {useEffect, useState} from "react";
import {IPublicTrainer} from "../../../models/Trainer";
import {getTrainerImage} from "../../../helpers/image.helper";
import {Link, useNavigate} from "react-router-dom";
import arrowRight from "../../../assets/images/icons/arrow-right-blue.svg";

const TrainersSection = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const {activeGym} = useAppSelector(state => state.multiGymsSlice);
    const {content} = useAppSelector(state => state.siteContentSlice);
    const {trainers} = useAppSelector(state => state.trainersSlice);

    const [filteredTrainers, setFilteredTrainers] = useState<IPublicTrainer[]>([]);

    useEffect(() => {
        if (content.trainersItems && trainers.length) {
            const settings = JSON.parse(content.trainersItems);
            const customSort = (a: any, b: any) => {
                const indexA = settings.order.indexOf(a.id);
                const indexB = settings.order.indexOf(b.id);
                return indexA - indexB;
            };
            const filteredAndSortedTrainers = trainers.filter(el => settings.selectedItems.includes(el.id)).sort(customSort);
            setFilteredTrainers(filteredAndSortedTrainers);
        }
    }, [trainers]);

    const clickOnTrainerItem = (id: number) => {
        navigate(`/trainers/${id}`);
    }

    return (
        <section className={styles.section}>
            <SectionTitle text={t("Trainers")}/>
            <div className={"container"}>
                <SectionSubtitle text={content.trainersDescription}/>
            </div>
            <div className={styles.backgroundWrapper}>
                <div className={"container"}>
                    <div className={styles.wrapper}>
                        {filteredTrainers.map(el => {
                            return (
                                <div
                                    onClick={() => clickOnTrainerItem(el.id)}
                                    className={styles.item}
                                    style={{backgroundImage: `url(${getTrainerImage(activeGym.endpoint, el)})`}}
                                >

                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className={styles.linkWrapper}>
                <Link className={styles.link} to={"/trainers"}>{t("SeeAllTrainers")}<img src={arrowRight}
                                                                                      alt={"move"}/></Link>
            </div>
        </section>
    )
}

export default TrainersSection;